import React, { useState, useEffect, useCallback } from "react";
import { useGetProductPlanHistoryQuery } from "../../../store/apiSlice/productApiSlice";
import { ActivityLogDrawer } from "./ActivityLogDrawer";
import { LinkButton } from "./index.styles";

const ActivityLogDrawerWrapper = ({ productPlanId, isOpen, onClose }) => {
  const limit = 20;
  const [offset, setOffset] = useState(0);
  const [accumulatedLogs, setAccumulatedLogs] = useState([]);

  const { data, isLoading, isError, isFetching } = useGetProductPlanHistoryQuery(
    { id: productPlanId, limit, offset },
    { refetchOnMountOrArgChange: true },
  );

  useEffect(() => {
    if (!data?.results) return;
    setAccumulatedLogs(prev => {
      if (offset === 0) return data.results;
      const seen = new Set(prev.map(row => row.id));
      return [...prev, ...data.results.filter(row => !seen.has(row.id))];
    });
  }, [data, offset]);

  const logs = accumulatedLogs;
  const showInitialLoading = isLoading && accumulatedLogs.length === 0;
  const hasMore = Boolean(data?.next);

  const handleLoadMore = useCallback(() => setOffset(prev => prev + limit), []);

  return (
    <ActivityLogDrawer
      isOpen={isOpen}
      onClose={onClose}
      logs={Array.isArray(logs) ? logs : []}
      isLoading={showInitialLoading}
      isError={isError}
      hasMore={hasMore}
      isFetching={isFetching}
      onLoadMore={handleLoadMore}
    />
  );
};

export const ActivityLogCell = ({ productPlanId, columnWidth }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = useCallback(() => setIsOpen(false), []);

  return (
    <td key="activity-log-cell">
      <div style={{ width: columnWidth || 100, textAlign: "left" }}>
        <LinkButton
          type="button"
          onClick={e => {
            e.stopPropagation();
            setIsOpen(true);
          }}
        >
          View
        </LinkButton>
      </div>
      {isOpen && (
        <ActivityLogDrawerWrapper
          productPlanId={productPlanId}
          isOpen={isOpen}
          onClose={handleClose}
        />
      )}
    </td>
  );
};
